export default class FacetActionHandler {
    getCurrentFacetInfo(query, payload) {
        const { facetId } = payload;
        const { facet: facets = [] } = query.getLastResponse() || {};
        const { value: facetValues = [], label: facetTitle = '' } = facets.find(({ name }) => name === facetId) || {};
        return {
            facetValues,
            facetTitle,
        };
    }
}
